import React, { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import FeedCard from '../components/FeedCard';
import Loader from '../components/Loader';

export default function News({ notify }) {
  const [items, setItems] = useState(null);
  const [query, setQuery] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      setItems(await api.feed('news'));
    } catch (e) {
      setError(e.message);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  async function runSearch(e) {
    e.preventDefault();
    if (!query.trim()) return load();
    setBusy(true);
    try {
      setItems((await api.search(query.trim())).filter((r) => r.type === 'news'));
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  async function pull() {
    setBusy(true);
    try {
      const r = await api.ingestNews();
      notify(r.added ? `${r.added} new headlines` : 'Nothing new on the wire');
      await load();
    } catch (e) {
      notify(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <div className="col-head">
        <h1 className="col-title">News</h1>
        <button className="btn ghost sm" onClick={pull} disabled={busy}>
          {busy ? '…' : 'Pull latest'}
        </button>
      </div>

      <form className="searchbar" onSubmit={runSearch}>
        <input
          className="in" value={query} placeholder="Search headlines…"
          onChange={(e) => setQuery(e.target.value)}
        />
        <button className="btn ghost sm" type="submit" disabled={busy}>Search</button>
        {query && (
          <button className="btn quiet sm" type="button" onClick={() => { setQuery(''); load(); }}>
            Clear
          </button>
        )}
      </form>

      <p className="rankline">
        Ranked by relevance to your profile, then freshness. Reacting and dismissing here is what
        trains your matcher.
      </p>

      {error && <div className="pe-error">{error}</div>}
      {items === null && <Loader label="Loading the wire…" />}
      {items?.length === 0 && (
        <div className="card pad empty-state">
          <b>Nothing on the wire</b>
          <button className="btn apply" onClick={pull}>PULL NEWS <span className="arw">›</span></button>
        </div>
      )}

      {items?.map((item) => (
        <FeedCard key={item.id} item={item} notify={notify} />
      ))}
    </>
  );
}
